<template>
  <div class="p-6 bg-gradient-to-b from-blue-100 to-white text-gray-800 font-sans">
    <h1 class="text-2xl font-bold mb-4">Admin corner</h1>

    <div class="flex space-x-4 border-b mb-4 bg-white p-4 rounded shadow">
      <router-link
        :to="`/admin/devices`"
        class="pb-2"
        :class="{ 'text-blue-600 border-b-2 border-blue-600': $route.path.includes('devices') }"
      >
        Devices List
      </router-link>
      
      <router-link
        :to="`/admin/usage`"
        class="pb-2"
        :class="{ 'text-blue-600 border-b-2 border-blue-600': $route.path.includes('usage') }"
      >
        Usage
      </router-link>
      
      <router-link
        :to="`/admin/telemetry`"
        class="pb-2"
        :class="{ 'text-blue-600 border-b-2 border-blue-600': $route.path.includes('telemetry') }"
      >
        Telemetry
      </router-link>
      
    </div>

    <router-view />
  </div>
</template>

<script>

export default {
};
</script>